import styled from "styled-components";

export const PromessaBox = styled.div`
  background: #0A2540;
  color: #ffffff;
  padding: 24px 20px;
  margin: 24px 0;
  border-radius: 8px;
  text-align: center;

  @media screen and (min-width: 768px) {
    padding: 40px 32px;
  }

  & h2,
  & h3,
  & h4 {
    color: #ffffff;
    margin-bottom: 16px;
  }

  & p,
  & li {
    color: #ffffff;
  }

  & strong {
    color: #ffffff;
  }
`;

const CalloutBase = styled.div`
  width: 100%;
  padding: 16px 20px;
  margin: 20px 0;
  border-radius: 6px;
  border-left: 6px solid;

  & p,
  & li {
    margin: 0;
    padding: 8px 0 0;
  }

  & ul,
  & ol {
    padding-left: 24px;
    margin-top: 8px;
  }

  & p:first-child,
  & h3:first-child,
  & h4:first-child {
    padding-top: 0;
  }

  & h3,
  & h4 {
    font-weight: 700;
    margin: 0 0 8px;
    font-size: 18px;
    line-height: 1.4;

    @media screen and (min-width: 1024px) {
      font-size: 20px;
    }
  }
`;

export const InfoCallout = styled(CalloutBase)`
  background: #E3F2FD;
  border-left-color: #0080ED;

  & h3,
  & h4 {
    color: #0B4F8A;
  }
`;

export const AlertCallout = styled(CalloutBase)`
  background: #FFF8E1;
  border-left-color: #F5A623;

  & h3,
  & h4 {
    color: #8A5A00;
  }
`;

export const SuccessCallout = styled(CalloutBase)`
  background: #E8F5E9;
  border-left-color: #2DB5B2;

  & h3,
  & h4 {
    color: #1B6E4A;
  }
`;

export const DangerCallout = styled(CalloutBase)`
  background: #FFEBEE;
  border-left-color: #EF6E67;

  & h3,
  & h4 {
    color: #8A1F1B;
  }
`;

export const MarcoBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E0E6ED;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }

  & .marco-number {
    background: #0A2540;
    color: #ffffff;
    font-size: 48px;
    font-weight: 700;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 20px;
    min-width: 100%;

    @media screen and (min-width: 768px) {
      min-width: 120px;
      font-size: 64px;
      padding: 24px;
    }
  }

  & .marco-body {
    background: #ffffff;
    padding: 16px 20px;
    flex: 1;
  }

  & .marco-body h3,
  & .marco-body h4 {
    color: #0080ED;
    margin: 0 0 8px;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.4;

    @media screen and (min-width: 1024px) {
      font-size: 20px;
    }
  }

  & .marco-body p {
    margin: 0;
    padding: 4px 0 0;
  }
`;

export const ChecklistItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;
  font-size: 18px;
  line-height: 1.6;

  @media screen and (min-width: 1024px) {
    font-size: 22px;
  }

  &::before {
    content: "✓";
    color: #2DB5B2;
    font-weight: 700;
    flex-shrink: 0;
    font-size: 20px;
    line-height: 1.6;

    @media screen and (min-width: 1024px) {
      font-size: 24px;
    }
  }
`;
